import { BRAND } from "../../type/EnumBrand";
import { IBrand } from "../../type/IBrand";

export const purpleaudio: IBrand = {
  id: "purple-audio",
  name: BRAND.PURPLE_AUDIO,
  logo: "/logo/purple-audio-logo.jpeg",
  website: "http://www.purpleaudio.com/",
  description: `
High quality studio equipment for large and small scale studios. Founded by Andrew Roberts in 1997 with the MC77 being their first product.   
Known for their MC77 FET Compressor, an aggressive and all round compressor that you can use on your instruments or buses. 
A great brand to consider for quality products at a great price. A must have especially for 500 series gear.  
  `,
  videos: ["https://www.youtube.com/embed/CrUIcjXbGRI", "https://www.youtube.com/embed/xV_WcHf_-sY"]
}